import { PrinterPosNetworkOutlineIcon } from './PrinterPosNetworkOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 3FD6D2F6-5BBB-45D9-BE28-1B216BEB4D5E
 * name printer-pos-network-outline
 * version: 7.1.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/printer-pos-network-outline.svg
 * tags
 * - Printer 
 */
export const PrinterPointOfSaleNetworkOutlineIcon = PrinterPosNetworkOutlineIcon;
export default PrinterPointOfSaleNetworkOutlineIcon